import { useState, useEffect } from "react";

const AssessmentQuestion = (props) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [answers, setAnswers] = useState([]);

  let preAssessmentData = [];
  //check if id exists and replace element
  function upsert(array, id, element) {
    const i = array.findIndex((el) => el.id === element.id);
    if (i > -1) array[i] = element;
    else {
      array.push(element);
      localStorage.setItem(`question${id}`, JSON.stringify(element));
    }
  }

  const pickScore = (id, data) => {
    upsert(preAssessmentData, id, data);
  };

  useEffect(() => {
    for (let index = 0; index < 30; index++) {
      const element = JSON.parse(localStorage.getItem(`question${index + 1}`));
      //answers.push(element);
      answers && setAnswers(element);
      console.log(answers);
    }
  }, []);

  return (
    <div className="assessment">
      <p className="assessment__question">{props.props.question}</p>
      <div className="assessment__options-wrapper">
        <div
          className="assessment__options-wrapper__strongly-disagree"
          onClick={() => {
            setSelectedOption("strongly-disagree");
            pickScore(props.props.id, { id: props.props.id, score: 2 });
          }}
        >
          <div
            className={
              selectedOption === "strongly-disagree"
                ? "selected-strongly-disagree"
                : "non-selected"
            }
          ></div>
          <p>Strongly disagree</p>
        </div>

        <div
          className="assessment__options-wrapper__disagree"
          onClick={() => {
            setSelectedOption("disagree");
            pickScore(props.props.id, { id: props.props.id, score: 4 });
          }}
        >
          <div
            className={
              selectedOption === "disagree"
                ? "selected-disagree"
                : "non-selected"
            }
          ></div>
          <p>Strongly</p>
        </div>

        <div
          className="assessment__options-wrapper__mid"
          onClick={() => {
            setSelectedOption("neutral");
            pickScore(props.props.id, { id: props.props.id, score: 6 });
          }}
        >
          <div
            className={
              selectedOption === "neutral" ? "selected-neutral" : "non-selected"
            }
          ></div>
          <p>Strongly</p>
        </div>

        <div
          className="assessment__options-wrapper__agree"
          onClick={() => {
            setSelectedOption("agree");
            pickScore(props.props.id, { id: props.props.id, score: 8 });
          }}
        >
          <div
            className={
              selectedOption === "agree" ? "selected-agree" : "non-selected"
            }
          ></div>
          <p>Strongly</p>
        </div>

        <div
          className="assessment__options-wrapper__strongly-agree"
          onClick={() => {
            setSelectedOption("strongly-agree");
            pickScore(props.props.id, { id: props.props.id, score: 10 });
          }}
        >
          <div
            className={
              selectedOption === "strongly-agree"
                ? "selected-strongly-agree"
                : "non-selected"
            }
          ></div>
          <p>Strongly agree</p>
        </div>
      </div>
    </div>
  );
};

export default AssessmentQuestion;
